import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

const DOC = gql`
  mutation AssignSurveyAdmin(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $userId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                assignSurveyAdmin(userId: $userId)
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.AssignSurveyAdminMutation,
  undefined,
  graphql.schema.AssignSurveyAdminMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
